import { User } from "shared/providers/context/types/auth-context";

import { IFormData } from "@CheckoutOnepageOffers/components/organisms/PurchaseForm/type";
import IOffer from "@CheckoutStepsOffers/@types/offer";
import { IData } from "@payment/hooks/usePayOffers";

interface IPaymentDataModeling {
  offer: IOffer;
  data: IFormData;
  loggedUser: User;
  userSettings: any;
  promoterLink: string;
  payment_method: string;
  cardId?: number | undefined | null;
  addressId?: number | undefined | null;
}

export function paymentDataModeling(payload: IPaymentDataModeling): IData {
  const {
    data,
    offer,
    cardId,
    addressId,
    loggedUser,
    promoterLink,
    userSettings,
    payment_method,
  } = payload;

  const getUserNames = () => {
    const nameSplitted = data?.user.name
      .split(" ")
      .filter((name) => name !== "" && name !== undefined && name !== null);

    const first_name = nameSplitted[0];
    const last_name = nameSplitted[nameSplitted?.length - 1];
    const display_name = data?.user.name;

    return {
      first_name,
      last_name,
      display_name,
    };
  };

  const getTypeDocument = () => {
    const document = data?.user?.document || userSettings?.payment?.document;

    if (!document) {
      return {
        type: "individual",
      };
    }

    if (document) {
      const documentCleaned = document.replace(/[^0-9]/g, "");

      if (documentCleaned.length === 11) {
        return {
          type: "individual",
          type_entity: "cpf",
        };
      }

      return {
        type: "corporation",
        type_entity: "cnpj",
      };
    }
  };

  const { type, type_entity } = getTypeDocument();

  let newObjectData;

  newObjectData = {
    type,
    type_entity,
    payment_method,
    group_id: offer.group.id,

    offer_id: offer.offer.id,
  };

  if (!!promoterLink) newObjectData["promoter_link"] = promoterLink;

  if (!!data?.user) {
    const { email, document, phone_number } = data?.user;
    const userNames = getUserNames();

    newObjectData = {
      ...newObjectData,
      ...data?.user,
      ...userNames,
      email,
      email_confirmation: email,
      phone_number: `+${phone_number.replace(/[^0-9]/g, "")}`,
    };

    if (document) {
      newObjectData.document = document.replace(/[^0-9]/g, "");
    }
  }

  if (!!data?.address) {
    newObjectData = {
      ...newObjectData,
      ...data?.address,
      zipcode: data?.address?.zipcode.replace(/[^0-9]/g, ""),
    };
  }

  if (offer.offer.details.enable_default_address) {
    newObjectData = {
      ...newObjectData,
      ...offer.offer.details.default_address,
    };
  }

  if (!!data?.credit_card) {
    newObjectData = {
      ...newObjectData,
      ...data?.credit_card,
      card_number: data?.credit_card?.card_number?.replace(/[^0-9]/g, ""),
      card_expiration_date: data?.credit_card?.card_expiration_date.replace(
        /[^0-9]/g,
        "",
      ),
      installments: data?.credit_card?.installments || "1",
    };
  }

  if (!!loggedUser) {
    if (!newObjectData.document)
      newObjectData["document"] =
        userSettings?.payment?.document || data?.document;
    if (!newObjectData.phone_number)
      newObjectData["phone_number"] =
        userSettings?.payment?.phone || data?.phone_number;
    if (!newObjectData.display_name)
      newObjectData["display_name"] =
        userSettings?.payment?.display_name || loggedUser.display_name;
    if (!newObjectData?.email)
      newObjectData["email"] = (
        userSettings?.payment?.email || loggedUser?.email
      )?.toLowerCase();

    if (cardId) {
      newObjectData = {
        ...newObjectData,
        card_id: cardId,
        installments: data?.installments || "1",
      };
    }

    if (addressId) {
      newObjectData = {
        ...newObjectData,
        address_id: addressId,
      };
    }
  }

  return newObjectData;
}
